/**
 * 계약자 및 조직 상세 컴포넌트
 * 계약자와 조직의 상세 정보를 표시하는 컴포넌트입니다.
 * 계약자의 이메일, 회원번호, 휴대폰, 사업자 여부 등의 정보와
 * 조직의 법인명/상호, 사업자 유형, 대표자/성명, 사업자 등록번호 등의 정보를 보여줍니다.
 */

import { useCallback, useEffect, useState } from "react";
import { Contractor, DetailTotalData } from "src/api/contract/contract-types";
import { MbOrgMedia } from "src/api/organization/org-types";
import pagePath from "src/pagePath.json";
import { formatPhoneNumber } from "src/utils";
import BaseSection from "../../../../components/layout/BaseSection";

/**
 * 컴포넌트 props 인터페이스
 */
interface ContractBasicProp {
  detailData: DetailTotalData; // 상품 상세 조회 정보
}

/**
 * 계약자 및 조직 상세 컴포넌트
 * @param detailData 계약 상세 데이터
 */
const ContractorAndOrganizationDetail = ({ detailData }: ContractBasicProp) => {
  const { contractManage, contractOrganization } = detailData;
  const [contractor, setContractor] = useState<Contractor>(); // 계약자 정보 상태
  const [organization, setOrganization] = useState<any>(); // 조직 정보 상태
  const [proof, setProof] = useState<MbOrgMedia[]>(); // 증빙 자료 상태
  const [orgShow, setOrgShow] = useState(false); // 조직 정보 표시 여부 상태

  /**
   * 조직 상세 페이지 URL 생성 함수
   * @param id 조직 ID
   * @returns 조직 상세 페이지 URL
   */
  const moveOrg = useCallback((id: number) => {
    let rtn = "";
    if (id) {
      rtn = pagePath.organization.detail.replace(":id", String(id));
    }
    return rtn;
  }, []);

  /**
   * 데이터 초기화 함수
   * 계약자 정보와 조직 정보를 초기화하고, 증빙 자료를 필터링합니다.
   */
  const initDatas = useCallback(() => {
    if (contractManage && contractManage?.contractorList) {
      const findedContractor = contractManage?.contractorList!.find((user: Contractor) => user.isContractor);
      if (findedContractor) {
        setContractor(findedContractor);
      }

      if (contractManage?.mbOrganizationId === "0") {
        setOrgShow(false);
      } else {
        setOrgShow(true);
      }

      setOrganization(contractOrganization?.organization);
      const proofs = contractOrganization?.mediaList!.filter((media: any) => media.type === "PROOF");
      setProof(proofs);
    }
  }, [contractManage, contractOrganization?.mediaList, contractOrganization?.organization]);

  // 컴포넌트 마운트 시 데이터 초기화
  useEffect(() => {
    initDatas();
  }, [initDatas]);

  return (
    <>
      <div className="flex-center">
        <BaseSection title={"이메일"} value={contractor?.memberEmail} />
        <BaseSection title={"회원 번호"} value={contractor?.memberNo} />
      </div>
      <div className="flex-center">
        <BaseSection title={"휴대폰"} value={formatPhoneNumber(String(contractor?.memberPhoneNumber))} />
        <BaseSection title={""} value={""} />
      </div>
    </>
  );
};

export default ContractorAndOrganizationDetail;
